import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { makeTextFieldClear, TextField } from 'shared/ui/TextField'
import { IconButton } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { type HubspotWorkflowRow } from 'entities/HubspotWorkflows/model/HubspotWorkflowRow'
import { HubspotWorkflowsPath } from 'entities/ExportRouters'
import { useHubspotWorkflowsListContext } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/context/context'
import { useEventOrganizationHubspotWorkflowSyncFinished } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/events/EventOrganizationHubspotWorkflowSyncFinished'
import styles from './styles.module.scss'
import { getColumns } from './getColumns'

export const HubspotWorkflowsTable = observer(() => {
  const store = useHubspotWorkflowsListContext()
  const { search, setSearch, items, startSync, onPaginationModelChange, tableStore, reSync } = store

  useEventOrganizationHubspotWorkflowSyncFinished(store)

  const columns = useMemo(getColumns, [])

  const getRowLink = (row: HubspotWorkflowRow) => `/${HubspotWorkflowsPath.view}/${row.id}`

  return (
    <div className={styles.wrap}>
      <TextField
        size={'medium'}
        onChange={setSearch}
        variant={'integrated'}
        value={search}
        className={styles.searchWrap}
        InputProps={{
          placeholder: 'Search...',
          className: styles.search,
        }}
        rightActions={[
          makeTextFieldClear({
            isButton: true,
            isVisibleWithoutFocus: true,
            intent: 'passive',
          }),
        ]}
      />

      <div className={styles.table}>
        <Table
          ariaLabel={'HubspotWorkflowsTable'}
          store={tableStore}
          columns={columns}
          rows={items}
          pinnedColumnIds={['name']}
          onChangePagination={onPaginationModelChange}
          getRowLink={getRowLink}
          emptyStateProps={{ text: 'No HubSpot workflows found' }}
          rightHeaderContent={
            <IconButton
              iconProps={{
                fontSize: 16,
              }}
              loading={startSync}
              variant={'icon'}
              color={'tertiary'}
              size={'small'}
              icon={'refresh'}
              ariaLabel='Refresh_data'
              tooltipProps={{
                label: startSync ? 'In progress' : 'Resync',
                placement: 'top',
              }}
              onClick={() => {
                reSync()
              }}
            />
          }
        />
      </div>
    </div>
  )
})
